/**
 * Text used in the attachments and waivers page.
 */
export const AttachmentsAndWaiversHelperMessages = {
    comments:
        'Notes (Enter any special instructions and/or details you would like to communicate to your EWA Advisor.)',
    anyAdditionalAttachments:
        'Would like EWA to prepare any additional attachments or waivers on your behalf?',
} as const;
